import { render, staticRenderFns } from "./subir-archivos.vue?vue&type=template&id=91265498&scoped=true&"
import script from "./subir-archivos.vue?vue&type=script&lang=js&"
export * from "./subir-archivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91265498",
  null
  
)

export default component.exports